import { axiosInstance } from "./axiosInstance";

export const getUsersVerificationApplications = async (
  search = "",
  verification_status = ""
) => {
  try {
    const kycList = (
      await axiosInstance.get("kyc/users", {
        params: { search: search, verification_status: verification_status },
      })
    ).data;
    if (kycList && kycList.data) {
      return kycList.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getFileTempLink = async (data) => {
  try {
    const kycLFile = (await axiosInstance.post(`kyc/admin/file`, data)).data;
    if (kycLFile && kycLFile.data) {
      return kycLFile.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const verifyUser = async (id, data) => {
  try {
    const kyc = (await axiosInstance.post(`kyc/verify/${id}`, data)).data;
    if (kyc && kyc.data) {
      return kyc.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const releasePaymentUser = async (data) => {
  try {
    const kyc = (await axiosInstance.post(`/kyc/user/email/approve`, data)).data;

    if (kyc && kyc.data) {
      return kyc.data;
    }
    return null;
  } catch (error) {
    return error;
  }
};

export const exportAllKYCExcel = async (data) => {
  try {
    const res = (await axiosInstance.get(`/kyc/users/export-excel`)).data;

    if (res) {
      return res;
    }
    return null;
  } catch (error) {
    return error;
  }
};
